import "./WhyBusinessesNeedVPNs.module.css";
import Header from "@/reusable_sections/Header";
import Businessvpnhero from "./sections/Businessvpnhero";
import Vpnenterprisedataprotection from "./sections/Vpnenterprisedataprotection";
import Compliance from "./sections/Compliance";
import Protocol from "./sections/Protocol";
import RelatedArticlesGrid from "./sections/RelatedArticlesGrid";
import Footer from "@/reusable_sections/Footer";
export default function WhyBusinessesNeedVPNsPage() {
  return <div>
      <Header />
      <Businessvpnhero />
      <Vpnenterprisedataprotection />
      <Compliance />
      <Protocol />
      <RelatedArticlesGrid />
      <Footer />
    </div>;
}